import { useEffect, useRef, useState } from "react";
import "../../../styles/process-animations.css";

const ProcessSection = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    const steps = [
        {
            number: "01",
            title: "Discover & Plan",
            description: "We begin by understanding your goals, audience, and vision to create a strategic roadmap tailored to your needs."
        },
        {
            number: "02",
            title: "Design & Develop",
            description: "Our team crafts intuitive designs and develops high-performance solutions, ensuring seamless functionality and engaging user experiences."
        },
        {
            number: "03",
            title: "Launch & Support",
            description: "We launch with precision and provide ongoing support, continuously optimizing for performance and growth as your needs evolve."
        }
    ];

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    // Start the step progression after section is visible
                    const stepInterval = setInterval(() => {
                        setActiveStep(prev => {
                            if (prev < steps.length - 1) return prev + 1;
                            clearInterval(stepInterval);
                            return prev;
                        });
                    }, 800);
                    return () => clearInterval(stepInterval);
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, [steps.length]);

    return (
        <div className="section overflow-hidden" ref={sectionRef}>
            <div className="container-default w-container">
                <div className={`inner-container _1068px center process-header ${isVisible ? 'animate-in' : ''}`}>
                    <div className="text-center">
                        <div className="big-font-title display-2---size">Process</div>
                        <h2 className="display-2 mg-bottom-64px">A simple, yet effective three step process</h2>
                    </div>
                </div>
            </div>
            
            <div className="position-relative process-cards-wrapper">
                <div className="container-default w-container">
                    <div className="process-steps-container">
                        {steps.map((step, index) => (
                            <div 
                                key={step.number}
                                className={`process-step-card ${isVisible ? 'animate-in' : ''} ${index <= activeStep ? 'active' : ''}`}
                                style={{ animationDelay: `${0.2 + index * 0.15}s` }}
                            >
                                <div className="process-step-number-wrapper">
                                    <span className={`process-step-number ${index <= activeStep ? 'pulse' : ''}`}>
                                        {step.number}
                                    </span>
                                    {index < steps.length - 1 && (
                                        <div className={`process-connector ${index < activeStep ? 'filled' : ''}`}>
                                            <div className="process-connector-fill"></div>
                                        </div>
                                    )}
                                </div>
                                <div className="process-step-content">
                                    <h3 className="display-4 mg-bottom-12px">{step.title}</h3>
                                    <p className="mg-bottom-0px---tablet">{step.description}</p>
                                </div>
                                <div className={`process-step-glow ${index <= activeStep ? 'active' : ''}`}></div>
                            </div>
                        ))}
                    </div>
                    
                    {/* Progress bar */}
                    <div className="process-progress-bar">
                        <div 
                            className="process-progress-fill" 
                            style={{ width: `${((activeStep + 1) / steps.length) * 100}%` }}
                        ></div>
                    </div>
                </div>
            </div>
            
            <div className="container-default w-container">
                <div className={`buttons-row center process-cta ${isVisible ? 'animate-in' : ''}`}>
                    <a href="/contact" className="btn-secondary w-button">Contact us</a>
                </div>
            </div>
        </div>
    )
}

export default ProcessSection
